export default {
    COMPANY_TYPES: {
        COMPANY: 0,
        AGENCY: 1,
    },
    EVENT_TYPE: {
        WORLD_CONGRESS: 0,
        PAID_LIVE_DAY: 1,
    },
    WORKSHOP_MAX_REGISTRATIONS_PER_USER: 4,
    EVENT_TRACKING: {
        JOB_CARD_VIEW: 'job.card-view',
        JOB_CARD_EXPAND: 'job.card-expand',
        JOB_CARD_DETAILS_CLICK: 'job.card-job-details-click',
        JOB_CARD_COMPANY_CLICK: 'job.card-company-click',
        JOB_CARD_CATEGORY_CLICK: 'job.card-category-click',
        JOB_CARD_INTERACT: 'job.card-interact',
        JOB_CARD_APPLY_CLICK: 'job.card-apply-click',
        JOB_APPLY_INTERNAL_CLICK: 'job.apply-internal-click',
        JOB_APPLY_EXTERNAL_CLICK: 'job.apply-external-click',
        JOB_PAGE_DIRECT_VIEW: 'job.page-direct-view',
        COMPANY_CARD_VIEW: 'company.card-view',
        COMPANY_CARD_DETAILS_CLICK: 'company.card-details-click',
        COMPANY_CARD_CATEGORY_CLICK: 'company.card-category-click',
        COMPANY_PAGE_STORY_INTERACTION: 'company.page-story-interaction',
        COMPANY_PAGE_DIRECT_VIEW: 'company.page-direct-view',
        JOB_LISTING_VIEW: 'job-listing.view',
        JOB_LISTING_CATEGORY_CLICK: 'job-listing.category-click',
        JOB_LISTING_CARD_APPLY_CLICK: 'job-listing.card-apply-click',
        JOB_LISTING_APPLY_EXTERNAL: 'job-listing.apply-external-click',
        SEARCH_JOBS: 'search.jobs',
        SEARCH_COMPANIES: 'search.companies',
        SEARCH_VIDEOS: 'search.videos',
        CANDIDATE_CV_CLICK: 'candidate.cv-company-click',
        CANDIDATE_LINKEDIN_CLICK: 'candidate.linkedin-company-click',
        CANDIDATE_DETAILS_CLICK: 'candidate.show-details-company-click',
        VIDEO_STARTED: 'video.play-started',
        COMMUNITY_PARTNER_AD_VIEW: 'ads.community-partner-view',
        COMMUNITY_PARTNER_AD_CLICK: 'ads.community-partner-click',
        LIVE_EVENT_DETAILS_PAGE_VIEW: 'live-event.details-page-view',
        LIVE_EVENT_DETAILS_LIVE_PLAY: 'live-event.live-play',
        LIVE_EVENT_DETAILS_RECORDING_PLAY: 'live-event.recording-play',
        LIVE_EVENT_AD_VIEW: 'live-event.ad-view',
        LIVE_EVENT_AD_CLICK: 'live-event.ad-click',
        LIVE_EVENT_PARTNER_CLICK: 'live-event.partner-click',
        LIVE_EVENT_SPONSOR_CLICK: 'live-event.sponsor-click',
    },
    TICKET_TOKEN_RESPONSE_CODE: {
        INVALID: 'APP_ACCESS_TOKEN_INVALID',
        EXPIRED: 'APP_ACCESS_TOKEN_EXPIRED',
        ALREADY_ASSIGNED: 'TICKET_ALREADY_ASSIGNED',
    },
    EVENT_USER_CONNECTION_STATUS: {
      DEFAULT: 0,
      PENDING: 1,
      ACCEPTED: 2,
      DENIED: 3,
    },
    ERRORS: {
        TOO_MANY_ATTEMPTS: 'TOO_MANY_ATTEMPTS'
    },
    NOTIFICATIONS: {
        TYPE: {
            TECHNICAL: 0,
            GENERIC: 1,
            EVENT_GENERIC: 2,
            EVENT_SESSION_REMINDER: 3,
            EVENT_SESSION_UPDATED: 4,
            EVENT_SESSION_CANCELLED: 5,
            EVENT_ATTENDEE_NEW_CONNECTION: 6,
            EVENT_ATTENDEE_ACCEPTED_CONNECTION: 7,
            EVENT_ATTENDEE_DENIED_CONNECTION: 8,
            EVENT_WORKSHOP_SEAT_ASSIGNED: 9,
            // Names the sender only — the message text stays in the thread and never
            // reaches the notification or the push payload. Coalesced server-side: one
            // unread entry per conversation, however many messages arrive.
            EVENT_ATTENDEE_NEW_MESSAGE: 10,
        }
    },
    EVENT_MENU_ITEM_TYPE: {
        URL: 1,
        IFRAME: 2,
    },
    OAUTH_STEP: {
        CONNECT_VIA_UNVERIFIED_EMAIL: 0,
        OTP_VERIFICATION: 1,
        TERMS_REQUIRED: 2,
    },
}
